/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Per_Unit_ItemInputs */

const en_admin_resource_form_per_unit_item = /** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per item`)
};

const de_admin_resource_form_per_unit_item = /** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Einheit`)
};

const es_admin_resource_form_per_unit_item = /** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por unidad`)
};

const fr_admin_resource_form_per_unit_item = /** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par unité`)
};

/** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */
const it_admin_resource_form_per_unit_item = en_admin_resource_form_per_unit_item;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */
const pt_br2_admin_resource_form_per_unit_item = en_admin_resource_form_per_unit_item;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */
const pl_admin_resource_form_per_unit_item = en_admin_resource_form_per_unit_item;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */
const hu_admin_resource_form_per_unit_item = en_admin_resource_form_per_unit_item;

/** @type {(inputs: Admin_Resource_Form_Per_Unit_ItemInputs) => LocalizedString} */
const ro_admin_resource_form_per_unit_item = en_admin_resource_form_per_unit_item;

/**
* | output |
* | --- |
* | "per item" |
*
* @param {Admin_Resource_Form_Per_Unit_ItemInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_per_unit_item = /** @type {((inputs?: Admin_Resource_Form_Per_Unit_ItemInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Per_Unit_ItemInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_per_unit_item(inputs)
	if (locale === "de") return de_admin_resource_form_per_unit_item(inputs)
	if (locale === "es") return es_admin_resource_form_per_unit_item(inputs)
	if (locale === "fr") return fr_admin_resource_form_per_unit_item(inputs)
	if (locale === "it") return it_admin_resource_form_per_unit_item(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_per_unit_item(inputs)
	if (locale === "pl") return pl_admin_resource_form_per_unit_item(inputs)
	if (locale === "hu") return hu_admin_resource_form_per_unit_item(inputs)
	return ro_admin_resource_form_per_unit_item(inputs)
});
export { admin_resource_form_per_unit_item as "admin.resource_form.per_unit_item" }